// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { HOME_GET_META_DATA_SUCCESS } from './constants';

export function setMetaData(data) {
  return {
    type: HOME_GET_META_DATA_SUCCESS,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_META_DATA_SUCCESS:
      return {
        ...state,
        metaData: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setMetaData.js